/**
 * Module definition and dependencies
 */
angular.module('Crm.Documents.Controller', ['ngMessages', 'ngFileUpload', 'documentsService.Service'])
/**
 * Controller
 */
.controller('ListeDocumentsCtrl', ['NgTableParams', 'DocumentsLot', 'DocumentsProgramme', 'DocumentsContact', '$filter', '$uibModal', '$scope', '$rootScope', function (NgTableParams, DocumentsLot, DocumentsProgramme, DocumentsContact, $filter, $uibModal, $scope, $rootScope) {
  var self = this;

  self.$onInit = () => {
    self.listDocumentsSelectionner = []; //Pour un contact

    if (self.contact && self.contact.id) {
      self.tableListeDocuments = new NgTableParams({}, {
        getData: params => {
          const query = {
            'limit': params.count(),
            'page': params.page(),
            'order': params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : '',
            'sort': params.sorting() ? Object.keys(params.sorting())[0] : '',
            'contactId': self.contact.id
          }; //Param pour ADV

          if ($rootScope.env && $rootScope.env === "immodesk") {
            query.adv = true;
          }

          return DocumentsContact.query(query).$promise.then(response => {
            params.total(response.total);
            self.totalDocuments = response.total;
            return response.data;
          }).catch(error => {
            console.log(error);
          });
        }
      });
      $scope.$on('updateListDocuments', () => {
        self.tableListeDocuments.reload();
      });
    } //Pour un programme


    if (self.programme && self.programme.id) {
      self.tableListeDocuments = new NgTableParams({}, {
        getData: function (params) {
          return DocumentsProgramme.query({
            'limit': params.count(),
            'page': params.page(),
            'order': params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : '',
            'sort': params.sorting() ? Object.keys(params.sorting())[0] : '',
            'programmeId': self.programme.id,
            'inclure_lots': 1
          }).$promise.then(function (response) {
            params.total(response.total);
            self.totalDocuments = response.total;
            return response.data;
          }).catch(function (err) {
            console.log('Promise error', err);
          });
        }
      });
      $scope.$on('updateListDocuments', function (event, data) {
        self.tableListeDocuments.reload();
      });
    } //Pour les lots


    if (self.lot && self.lot.id) {
      DocumentsLot.query({
        lotId: self.lot.id,
        limit: -1
      }).$promise.then(function (response) {
        self.listeDocuments = response.data;
      }).catch(function (err) {
        console.log('promise error', err);
      });
    }
  };

  self.titreLien = function (nom, titre) {
    if (titre) {
      return titre;
    }

    return nom;
  };

  self.getMimeIcon = function (mime) {
    if (!mime) {
      return 'glyphicon-file';
    }

    var icons = {
      image: 'glyphicon-picture',
      audio: 'glyphicon-volume-up',
      video: 'glyphicon-film',
      'text/plain': 'glyphicon-text-size',
      'text/html': 'glyphicon-text-background',
      'application/gzip': 'glyphicon-compress',
      'application/zip': 'glyphicon-compress'
    };

    if (icons[mime]) {
      return icons[mime];
    }

    var mime_parts = mime.split('/');
    mime = mime_parts[0];

    if (icons[mime]) {
      return icons[mime];
    } else {
      return 'glyphicon-file';
    }
  };

  self.selectionDocuments = function (item) {
    var doc = $filter('filter')(self.listDocumentsSelectionner, {
      id: item.id
    }, true)[0];
    var index = self.listDocumentsSelectionner.indexOf(doc);

    if (index == -1) {
      self.listDocumentsSelectionner.push(item);
    } else {
      self.listDocumentsSelectionner.splice(index, 1);
    }
  };
  /*******************************************************************************
   *
   * Modal openModalConfirmationDeleteDocument
   *
   ******************************************************************************/


  self.openModalConfirmationDeleteDocument = document => {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-confirmation-delete-document.html',
      controller: 'ConfirmerDeleteDocumentCtrl',
      controllerAs: '$ctrl',
      resolve: {
        document: () => {
          return document;
        }
      }
    });
    modalInstance.result.then(selectedItem => {
      self.selected = selectedItem;
    });
  };
  /*******************************************************************************
   *
   * Modal openModalEnvoyerDocument
   *
   ******************************************************************************/


  self.openModalEnvoyerDocument = function (document, objData) {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-upload-document.html',
      controller: 'modalUploadDocumentsCtrl',
      controllerAs: '$ctrl',
      resolve: {
        objData: function () {
          return objData;
        },
        document: function () {
          return document;
        },
        contact: function () {
          return self.contact === undefined ? 'null' : self.contact;
        }
      }
    });
  };
}]).controller('FormDocumentsCtrl', ['$scope', 'Programmes', 'ConfigsDocuments', function ($scope, Programmes, ConfigsDocuments) {
  var self = this;
  self.labelMultiSelect = {
    'itemsSelected': 'éléments sélectionnés',
    'selectAll': 'Tout sélectionner',
    'unselectAll': 'Tout déselectionner',
    'search': 'Chercher'
  };

  self.$onInit = function () {
    if (self.filtresDocuments === undefined) {
      self.filtresDocuments = {};
    }
    /* ---------- getProgrammes ---------- */


    Programmes.get({
      limit: -1
    }).$promise.then(function (response) {
      self.listProgrammes = response.data;
    }, function errorCallback(response) {
      console.log('Erreur factory Programmes get : ' + response);
      return false;
    });
    /* ---------- getCategories ---------- */

    ConfigsDocuments.getCategories().then(function (response) {
      self.listCategories = response.data;
    }, function errorCallback(response) {
      console.log('Erreur factory Programmes get : ' + response);
      return false;
    });
  };

  $scope.$watch(() => {
    return self.filtreDocuments;
  }, (val, old) => {
    angular.extend(self.filtresDocuments, val);
  }, true);
}]).controller('ListDocumentsCtrl', ['$scope', 'NgTableParams', 'Documents', 'debounce', '$filter', function ($scope, NgTableParams, Documents, debounce, $filter) {
  var self = this;

  self.$onInit = function () {
    if (self.documents === undefined) {
      self.documents = [];
    }

    if (!self.totalSize) {
      self.totalSize = 0;
    }
  };

  self.listDocuments = new NgTableParams({}, {
    getData: function (params) {
      self.loading = true;
      var query = {
        'limit': params.count(),
        'page': params.page(),
        'order': params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : '',
        'sort': params.sorting() ? Object.keys(params.sorting())[0] : ''
      };
      angular.extend(query, params.filter());
      return Documents.query(query).$promise.then(function (response) {
        self.loading = false;
        self.totalResult = response.total;
        return response.data;
      }).catch(function (err) {
        console.log('promise error', err);
      });
    }
  });

  self.selectionDocuments = function (item) {
    var doc = $filter('filter')(self.documents, {
      id: item.id
    }, true)[0];
    var index = self.documents.indexOf(doc);

    if (index == -1) {
      self.documents.push(item);
    } else {
      self.documents.splice(index, 1);
    }

    self.totalSize = 0;
    angular.forEach(self.documents, function (item, key) {
      if (item.size) {
        self.totalSize += parseFloat(item.size);
      }
    });
  };

  self.isChecked = function (item) {
    if (item.id && $filter('filter')(self.documents, {
      id: item.id
    }, true)[0]) {
      return true;
    }

    return false;
  };

  $scope.$watch(() => this.filtresDocuments, debounce(300, function () {
    angular.extend(self.listDocuments.filter(), self.filtresDocuments);
  }), true);
}]).controller('ListDocumentsProgrammeLotCtrl', ['DocumentsProgramme', 'DocumentsLot', '$filter', '$q', function (DocumentsProgramme, DocumentsLot, $filter, $q) {
  var self = this;

  self.$onInit = function () {
    if (self.documents === undefined) {
      self.documents = [];
    }

    if (!self.totalSize) {
      self.totalSize = 0;
    }

    self.labelSelectionnerDocuments = "Tout sélectionner";
    self.documentsProgrammeLot = [];
    self.getDocuments();
  };

  self.getDocuments = function () {
    self.loading = true;
    $q.all([self.getDocumentsProgramme(), self.getDocumentsLot()]).then(function (data) {
      self.loading = false;

      if (!Array.isArray(data)) {
        return;
      }

      data.forEach(function (element) {
        if (!Array.isArray(element)) {
          return;
        }

        self.documentsProgrammeLot = self.documentsProgrammeLot.concat(element);
      });
    }).catch(function (err) {
      console.log('error : ', err);
    });
  };

  self.getDocumentsProgramme = function () {
    return DocumentsProgramme.get({
      programmeId: self.programmeId,
      limit: 50
    }).$promise.then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.log('promise error', err);
    });
  };

  self.getDocumentsLot = function () {
    return DocumentsLot.get({
      lotId: self.lotId,
      limit: 50
    }).$promise.then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.log('promise error', err);
    });
  };

  self.selectionDocuments = function (item) {
    var doc = $filter('filter')(self.documents, {
      id: item.id
    }, true)[0];
    var index = self.documents.indexOf(doc);

    if (index == -1) {
      self.documents.push(item);
    } else {
      self.documents.splice(index, 1);
    }

    self.calcTotalSize();
  };

  self.toggleSelectionnerDocuments = function () {
    if (self.checkboxSelectionnerDocuments) {
      self.labelSelectionnerDocuments = "Tout désélectionner";
      self.documentsProgrammeLot.forEach(function (element) {
        const elementIsSelected = self.documents.find(d => d.id === element.id);

        if (!elementIsSelected) {
          self.documents.push(element);
        }
      });
    } else {
      self.documentsProgrammeLot.forEach(function (element) {
        self.labelSelectionnerDocuments = "Tout sélectionner";
        const elementIsSelected = self.documents.find(d => d.id === element.id);

        if (elementIsSelected) {
          const index = self.documents.indexOf(elementIsSelected);
          self.documents.splice(index, 1);
        }
      });
    }

    self.calcTotalSize();
  };

  self.calcTotalSize = function () {
    self.totalSize = 0;
    angular.forEach(self.documents, function (item, key) {
      if (item.size) {
        self.totalSize += parseFloat(item.size);
      }
    });
  };

  self.isChecked = function (item) {
    if (item.id && $filter('filter')(self.documents, {
      id: item.id
    }, true)[0]) {
      return true;
    }

    return false;
  };
}]).controller('ListTransactionDocumentsCtrl', ['NgTableParams', 'Documents', '$q', function (NgTableParams, Documents, $q) {
  var self = this;

  self.$onInit = function () {
    self.listDocuments = new NgTableParams({}, {
      getData: function () {
        return Documents.query({
          limit: -1,
          annexe_contrat: 'true',
          programme_id: self.transaction.programme_id
        }).$promise.then(res => {
          //return res[0].data;
          return res.data.filter(d => !d.lot_ids || d.lot_ids.indexOf(self.transaction.lot_id) > -1);
        });
      }
    });
  };

  self.selectionDocuments = function (item) {
    var index = self.documents.indexOf(item);

    if (index == -1) {
      self.documents.push(item);
    } else {
      self.documents.splice(index, 1);
    }

    self.totalSize = 0;
    angular.forEach(self.documents, function (item, key) {
      if (item.size) {
        self.totalSize += parseFloat(item.size);
      }
    });
  };
}]).controller('UploadDocumentsCtrl', ['Upload', function (Upload) {
  var self = this;
  self.datas = {};

  self.$onInit = function () {
    if (!self.documents) {
      self.documents = [];
    }

    if (!self.title) {
      self.title = 'Choisir un fichier';
    }

    if (!self.maxSize) {
      self.maxSize = 6291456;
    }

    if (!self.pattern) {
      self.pattern = '.jpg,.jpeg,.pdf,.odt,.ods,.docx,.doc,.xls,.xlsx,.png';
    }

    if (!self.useBase64) {
      self.useBase64 = false;
    }

    if (!self.useMultipart) {
      self.useMultipart = true;
      self.urlMultipart = '';
    }

    if (!self.totalSize) {
      self.totalSize = 0;
    }
  };

  self.uploadFiles = function (files, invalidFiles) {
    self.invalidFiles = invalidFiles && invalidFiles[0];
    angular.forEach(files, function (file) {
      if (self.useBase64) {
        files.upload = Upload.base64DataUrl(files).then(function (url) {
          fileTmp.base64 = url;
        });
      }

      self.documents.push(file);
      self.totalSize = 0;
      angular.forEach(self.documents, function (item, key) {
        if (item.size) {
          self.totalSize += parseFloat(item.size);
        }
      });
    });
  };
}]).controller('modalUploadDocumentsCtrl', ['$scope', 'objData', 'document', 'Config', 'Upload', '$rootScope', 'contact', 'DocumentsDemandes', 'ConfigsDocuments', function ($scope, objData, document, Config, Upload, $rootScope, contact, DocumentsDemandes, ConfigsDocuments) {
  var self = this;
  self.viewSend = 0;
  self.maxSizeFiles = 4400000;
  self.datas = {};
  self.document = document;
  self.objData = objData;
  self.contact = contact;
  self.urlApi = Config.API_BASE_URL + '/documents';
  self.urlApiMethod = 'POST';
  self.checkboxDemandeDocument = false;

  self.$onInit = function () {
    if (self.objData && self.objData.action && self.objData.action === 'updateDocument') {
      self.titleModal = "Mettre à jour un document - " + self.document.categorie_label;
      self.urlApi += self.document.id;
      self.urlApiMethod = 'PUT';
    } else if (self.objData && self.objData.action && self.objData.action === 'demandeDocument') {
      self.datas.demande_id = self.document.id;
      self.titleModal = "Déposer un document - " + self.document.media_categorie_label;
    } else if (self.objData && self.objData.action && self.objData.action === 'programme' && self.objData.programme) {
      self.datas.programme_id = self.objData.programme_id;
      self.titleModal = "Déposer un document pour le programme " + self.objData.programme.nom;
      ConfigsDocuments.getCategories({
        check_exist: 0,
        table_id: 22
      }).then(function (response) {
        self.listCategoriesProgramme = response.data;
      }, function errorCallback(response) {
        console.log('Erreur factory ConfigsDocuments getCategories : ' + response);
        return false;
      });
    } else {
      self.titleModal = "Déposer un document";
      self.checkboxDemandeDocument = false;
      ConfigsDocuments.getCategories({
        check_exist: 0,
        table_id: 34
      }).then(function (response) {
        self.listCategories = response.data;
      }, function errorCallback(response) {
        console.log('Erreur factory ConfigsDocuments getCategories : ' + response);
        return false;
      });
      DocumentsDemandes.query({
        'contact_id': self.contact.id,
        'done': 0
      }).$promise.then(function (response) {
        self.listDocumentsDemandes = response.data;

        if (self.listDocumentsDemandes.length > 0) {
          self.checkboxDemandeDocument = true;
        }
      }).catch(function (err) {
        console.log('Promise error', err);
      });
      self.datas.contact_id = self.contact.id;
    }
  };

  self.uploadMultiPart = function (files) {
    angular.forEach(files, function (file) {
      self.datas.file = file;
      file.upload = Upload.upload({
        url: self.urlApi,
        arrayKey: '.i',
        data: self.datas,
        method: self.urlApiMethod
      });
      file.upload.then(function (response) {
        if (!Array.isArray(self.arrayFilesUrls)) {
          self.arrayFilesUrls = [];
        }

        self.arrayFilesUrls.push(response.data);

        if (files.length === self.arrayFilesUrls.length) {
          self.viewSend = 2;
          $rootScope.$broadcast('updateListDocuments');
        }
      }, function (response) {
        if (response.status > 0) {
          $scope.errorMsg = response.status + ': ' + response.data;
        } else {
          self.errorUploadFiles = response;
        }
      }, function (evt) {
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    });
  };

  self.totalSizeFiles = function () {
    self.totalSizeListUploadDocuments = 0;

    if (self.listUploadDocuments) {
      angular.forEach(self.listUploadDocuments, function (item, key) {
        if (item.size) {
          self.totalSizeListUploadDocuments += parseFloat(item.size);
        }
      });
    }
  };

  self.supprimerDocuments = function (tab, index) {
    tab.splice(index, 1);
    self.totalSizeFiles();
  };

  self.upload = function () {
    if (!self.objData) return false;

    if (self.objData && self.objData.action === 'demandeDocument' && self.document && self.document.id) {
      self.datas.demande_id = self.document.id;
    }

    if (self.objData && self.objData.action === 'programme' && self.objData.programme) {
      self.datas.programme_id = self.objData.programme.id;
    }

    if (self.demandeSelected && self.demandeSelected.id) {
      self.datas.demande_id = self.demandeSelected.id;
    }

    if (self.categorieSelected && self.categorieSelected.id) {
      self.datas.categorie_id = self.categorieSelected.id;
    }

    if (self.listUploadDocuments.length > 0) {
      self.viewSend = 1;
      self.listUploadDocuments.progress = 0;
      self.uploadMultiPart(self.listUploadDocuments);
    }
  };

  self.checkBtnSubmit = function () {
    if (self.listUploadDocuments && !self.listUploadDocuments.length > 0 || self.totalSizeListUploadDocuments > self.maxSizeFiles || self.checkboxDemandeDocument && !self.demandeSelected || !self.checkboxDemandeDocument && !self.categorieSelected || self.objData && self.objData.action === 'programme' && !self.categorieSelected) {
      return true;
    }

    return false;
  };
}]).controller('DemandeDocumentsCtrl', ['$uibModalInstance', 'contact', 'showMessage', 'ConfigsDocuments', 'toaster', 'DocumentsDemandes', '$rootScope', '$scope', function ($uibModalInstance, contact, showMessage, ConfigsDocuments, toaster, DocumentsDemandes, $rootScope, $scope) {
  this.$onInit = () => {
    this.contact = contact;
    this.showMessage = showMessage;
    this.demandeDocuments = {};
    this.showCommentaire = false;
    ConfigsDocuments.getCategories({
      table_id: 34,
      check_exist: 0
    }).then(response => {
      this.listCategories = response.data;
    }).catch(error => {
      console.log(error);
    });
  };

  this.labelMultiSelect = {
    'itemsSelected': 'éléments sélectionnés',
    'selectAll': 'Tout sélectionner',
    'unselectAll': 'Tout déselectionner',
    'search': 'Chercher'
  };

  this.valider = () => {
    const query = {
      contact_id: this.contact.id,
      media_categorie_id: this.demandeDocuments.categories
    };

    if (this.demandeDocuments.note) {
      query.media_note = this.demandeDocuments.note;
    }

    if (this.contact.vendeur_id) {
      query.vendeur_id = this.contact.vendeur_id;
    }

    return DocumentsDemandes.save(query).$promise.then(() => {
      toaster.pop({
        type: 'success',
        title: '',
        body: 'Votre demande de documents à bien été envoyée.'
      });
      $rootScope.$broadcast('updateListDocuments');
      $uibModalInstance.close();
    }).catch(error => {
      toaster.pop({
        type: 'error',
        title: '',
        body: 'Erreur lors de la demande de documents.'
      });
      console.log("Erreur factory DocumentsDemandes query : " + error);
      return false;
    });
  };

  this.annuler = () => {
    $uibModalInstance.close();
  };

  $scope.$watch(() => this.demandeDocuments, () => {
    if (!this.demandeDocuments || !this.demandeDocuments.categories) {
      this.showCommentaire = false;
      return;
    }

    this.showCommentaire = this.demandeDocuments.categories.split(',').length === 1;
  }, true);
}]).controller('ListDemandesDocumentsCtrl', ['DocumentsDemandes', '$uibModal', 'NgTableParams', '$scope', '$rootScope', function (DocumentsDemandes, $uibModal, NgTableParams, $scope, $rootScope) {
  this.totalDemandesDocuments = 0;

  this.$onInit = () => {
    this.tableListDemandesDocuments = new NgTableParams({}, {
      getData: params => {
        const query = {
          'limit': params.count(),
          'page': params.page(),
          'order': params.sorting() ? params.sorting()[Object.keys(params.sorting())[0]] : '',
          'sort': params.sorting() ? Object.keys(params.sorting())[0] : '',
          'contact_id': this.contact.id,
          'done': 0
        }; //Param pour ADV

        if ($rootScope.env && $rootScope.env === "immodesk") {
          query.adv = true;
        }

        return DocumentsDemandes.query(query).$promise.then(response => {
          params.total(response.total);
          this.totalDemandesDocuments = response.total;
          return response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    });
  };

  $scope.$on('updateListDocuments', () => {
    this.tableListDemandesDocuments.reload();
  });
  /*******************************************************************************
   *
   * Modal openModalContact
   *
   ******************************************************************************/

  this.openModalValiderDocuments = document => {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-confirmation-list-demandes-documents.html',
      controller: 'ConfirmerDemandeDocumentCtrl',
      controllerAs: '$ctrl',
      resolve: {
        document: () => {
          return document;
        }
      }
    });
  };
  /*******************************************************************************
   *
   * Modal openModalConfirmationDeleteDemandeDocument
   *
   ******************************************************************************/


  this.openModalConfirmationDeleteDemandeDocument = document => {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-confirmation-delete-demande-document.html',
      controller: 'ConfirmerDeleteDemandeDocumentCtrl',
      controllerAs: '$ctrl',
      resolve: {
        document: () => {
          return document;
        }
      }
    });
  };
  /*******************************************************************************
   *
   * Modal openModalEnvoyerDocument
   *
   ******************************************************************************/


  this.openModalEnvoyerDocument = (document, objData) => {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-upload-document.html',
      controller: 'modalUploadDocumentsCtrl',
      controllerAs: '$ctrl',
      resolve: {
        objData: () => {
          return objData;
        },
        document: () => {
          return document;
        },
        contact: () => {
          return this.contact;
        }
      }
    });
  };
  /*******************************************************************************
   *
   * Modal openModalDemandeDocuments
   *
   ******************************************************************************/


  this.openModalDemandeDocuments = () => {
    var modalInstance = $uibModal.open({
      templateUrl: 'src/documents/modal-demande-documents.html',
      controller: 'DemandeDocumentsCtrl',
      controllerAs: '$ctrl',
      resolve: {
        contact: () => {
          return this.contact;
        },
        showMessage: () => {
          return !this.contact.vendeur_id;
        }
      }
    });
    modalInstance.result.then(selectedItem => {
      this.selected = selectedItem;
    });
  };
}]).controller('ConfirmerDemandeDocumentCtrl', ['$uibModalInstance', 'toaster', 'document', 'DocumentsDemandes', '$state', function ($uibModalInstance, toaster, document, DocumentsDemandes, $state) {
  var self = this;

  self.$onInit = function () {
    self.demandeDocument = document;
  };

  self.valider = function () {
    var doc = new DocumentsDemandes({
      demandeId: self.demandeDocument.id,
      done: 1
    });
    return doc.$update().then(function successCallback(response) {
      toaster.pop({
        type: 'success',
        title: '',
        body: 'Votre document a été validé.'
      });
      $uibModalInstance.close();
      $state.reload();
    }, function errorCallback(response) {
      console.log('Erreur factory DocumentsDemandes $update : ' + response);
      return false;
    });
  };

  self.annuler = function () {
    $uibModalInstance.close();
  };
}]).controller('ConfirmerDeleteDocumentCtrl', ['$uibModalInstance', 'toaster', 'document', 'Documents', '$rootScope', function ($uibModalInstance, toaster, document, Documents, $rootScope) {
  var self = this;

  self.$onInit = () => {
    self.document = document;
  };

  self.valider = () => {
    if (!self.document || !self.document.id) {
      return;
    }

    return Documents.remove({
      documentId: self.document.id
    }).$promise.then(() => {
      $rootScope.$broadcast('updateListDocuments');
      toaster.pop({
        type: 'success',
        title: '',
        body: 'Votre document a bien été supprimé.'
      });
      $uibModalInstance.close();
    }).catch(error => {
      console.log(error);
    });
  };
}]).controller('ConfirmerDeleteDemandeDocumentCtrl', ['$uibModalInstance', 'toaster', 'document', 'DocumentsDemandes', '$rootScope', function ($uibModalInstance, toaster, document, DocumentsDemandes, $rootScope) {
  var self = this;

  self.$onInit = function () {
    self.document = document;
  };

  self.valider = function () {
    return DocumentsDemandes.remove({
      demandeId: self.document.id
    }).$promise.then(function successCallback(response) {
      $rootScope.$broadcast('updateListDocuments');
      toaster.pop({
        type: 'success',
        title: '',
        body: 'Votre demande de document a bien été supprimée.'
      });
      $uibModalInstance.close();
    }, function errorCallback(response) {
      console.log('Erreur factory DocumentsDemandes remove : ' + response);
      return false;
    });
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module('Crm.Documents', ['Crm.Documents.Controller', 'Crm.documents.templates'])
/**
 * Route component
 */
.component('listeDocumentsLot', {
  controller: 'ListeDocumentsCtrl',
  templateUrl: 'src/documents/listeDocumentsPanelUl.html',
  bindings: {
    lot: '<',
    showPanelHeading: '<'
  }
}).component('listeDocumentsProgramme', {
  controller: 'ListeDocumentsCtrl',
  templateUrl: 'src/documents/listeDocumentsUl.html',
  bindings: {
    programme: '<',
    showPanelHeading: '<',
    listDocumentsSelectionner: '=',
    showColCheckbox: '<',
    view: '<',
    useAdminPromoteurOnly: '<'
  }
}).component('listeDocumentsContact', {
  controller: 'ListeDocumentsCtrl',
  templateUrl: 'src/documents/listeDocumentsUl.html',
  bindings: {
    contact: '<',
    showPanelHeading: '<',
    showColCheckbox: '<'
  }
}).component('formDocuments', {
  controller: 'FormDocumentsCtrl',
  templateUrl: 'src/documents/formDocuments.html',
  bindings: {
    filtresDocuments: '='
  }
}).component('listDocuments', {
  controller: 'ListDocumentsCtrl',
  templateUrl: 'src/documents/listDocuments.html',
  bindings: {
    filtresDocuments: '<',
    documents: '=',
    totalSize: '='
  }
}).component('listDocumentsProgrammeLot', {
  controller: 'ListDocumentsProgrammeLotCtrl',
  templateUrl: 'src/documents/listDocumentsProgrammeLot.html',
  bindings: {
    programmeId: '<',
    lotId: '<',
    documents: '=',
    totalSize: '='
  }
}).component('listTransactionDocuments', {
  controller: 'ListTransactionDocumentsCtrl',
  templateUrl: 'src/documents/listDocuments.html',
  bindings: {
    transaction: '<',
    documents: '='
  }
}).component('uploadDocumentsBtn', {
  controller: 'UploadDocumentsCtrl',
  templateUrl: 'src/documents/uploadDocumentsBtn.html',
  bindings: {
    documents: '=',
    title: '<',
    maxSize: '<',
    pattern: '<',
    useBase64: '<',
    totalSize: '='
  }
}).component('uploadDocumentsDragDrop', {
  controller: 'UploadDocumentsCtrl',
  templateUrl: 'src/documents/uploadDocumentsDragDrop.html',
  bindings: {
    documents: '=',
    title: '<',
    pattern: '<',
    useBase64: '<',
    totalSize: '='
  }
}).component('listDemandesDocuments', {
  controller: 'ListDemandesDocumentsCtrl',
  templateUrl: 'src/documents/listDemandesDocuments.html',
  bindings: {
    contact: '<'
  }
});
/**
 * Module definition and dependencies
 */

angular.module("documentsService.Service", ["ngResource"])
/**
 * Service
 */
.factory("DocumentsLot", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents?lot_id=:lotId", {
    lotId: "@lotId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("DocumentsProgramme", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents?programme_id=:programmeId", {
    programmeId: "@programmeId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("DocumentsContact", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents/contacts?contact_id=:contactId", {
    contactId: "@contactId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("VerifTemplates", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents/verif-templates/:programmeId", {
    programmeId: "@programmeId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("SendArr", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL_PUBLIC + "/transactions/:transactionId/documents/:documentId/procedure?sendArr=true&key=" + Config.SIGNATURE_WEBHOOK_KEY, {
    transactionId: "@transactionId",
    documentId: "@documentId"
  }, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("ReStartArr", ["$resource", "Config", function ($resource, Config) {
  var interceptor = {
    response: function (response) {
      return response;
    }
  };
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/documents/:documentId/ars", {
    transactionId: "@transactionId",
    documentId: "@documentId"
  }, {
    delete: {
      method: "DELETE",
      interceptor: interceptor
    },
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("Documents", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents/:documentId", {
    documentId: "@documentId"
  }, {
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("DocumentsDemandes", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/documents/demandes/:demandeId", {
    demandeId: "@demandeId"
  }, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });
  return api;
}]).factory("DocumentsProcedure", ["$resource", "Config", function ($resource, Config) {
  var api = $resource(Config.API_BASE_URL + "/transactions/:transactionId/documents/:documentId/procedure", {
    transactionId: "@transactionId",
    documentId: "@documentId"
  }, {
    update: {
      method: "PUT"
    },
    query: {
      isArray: false
    }
  });
  return api;
}]);
angular.module('Crm.documents.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/documents/formDocuments.html','<div class="row mb-1"><div class="col-xs-12 col-md-6"><div class="form-group"><div class="form-group--select" ng-if="$ctrl.listProgrammes"> <i class="material-icons">arrow_drop_down</i><multiselect id="programmes" name="programmes" classes-btn="\'form-control\'" model-string-to-object-array ng-model="$ctrl.filtreDocuments.programme_id" options="$ctrl.listProgrammes" placeholder="Programme" labels="$ctrl.labelMultiSelect" id-prop="id" display-prop="nom" show-search="false" show-select-all="false" show-unselect-all="false"></multiselect></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group"><div class="form-group--select" ng-if="$ctrl.listCategories"> <i class="material-icons">arrow_drop_down</i><multiselect id="categories" name="categories" classes-btn="\'form-control\'" model-string-to-object-array ng-model="$ctrl.filtreDocuments.categorie_id" options="$ctrl.listCategories" placeholder="Cat\xE9gories" labels="$ctrl.labelMultiSelect" id-prop="id" display-prop="label" show-search="false" show-select-all="false" show-unselect-all="false"></multiselect></div></div></div><div class="col-xs-12 col-md-12" ng-if="$ctrl.filtreDocuments.programme_id.length"><div class="form-group"><div class="pull-left mt-05"> <input type="checkbox" ng-model="$ctrl.filtreDocuments.inclure_lots" id="inclure_lots" ng-disabled="!$ctrl.filtreDocuments.programme_id.length" ng-true-value="1" ng-false-value="0" ng-checked="$ctrl.filtreDocuments.inclure_lots == 1"/> <label for="inclure_lots" class="checkbox" ng-class="{\'disabled\': !$ctrl.filtreDocuments.programme_id.length}">Inclure les documents li\xE9s aux lots</label></div></div></div></div>');
$templateCache.put('src/documents/listDemandesDocuments.html','<div ng-class="$ctrl.totalDemandesDocuments < 10 ? \'hiddenPager\' : \'\'"><h4>Documents demand\xE9s <button class="btn btn-tertiary btn-sm pull-right mt--05" ng-click="$ctrl.openModalDemandeDocuments()" ng-if="$ctrl.contact.id && $ctrl.contact.statut_activation">Demander un document</button></h4><table ng-table="$ctrl.tableListDemandesDocuments" class="table table-bordered table-striped table-responsive table-center mt-1"><tr ng-repeat="item in $data"><td title="\'Date\'">{{ item.date_creation.date | moment:\'DD/MM/YYYY\' }}</td><td title="\'Categorie\'">{{ item.media_categorie_label }}<span ng-if="item.media_note" class="pushpin" uib-popover="{{ item.media_note }}" popover-trigger="\'mouseenter\'"><span class="glyphicon glyphicon-info-sign"></span></span></td><td title="\'Vendeur\'">{{ item.vendeur_nom }}&nbsp;{{ item.vendeur_prenom }}</td><td title="\'\'" style="width: 115px;"><div class="btn-group" uib-dropdown is-open="status.isopen"> <button id="button-signature" type="button" class="btn btn-secondary" uib-dropdown-toggle ng-disabled="disabled"> Action<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="button-signature"><li role="menuitem"> <a title="Marquer comme re\xE7u" ng-click="$ctrl.openModalValiderDocuments(item)">Marquer comme re\xE7u</a></li><li role="menuitem"> <a title="D\xE9poser un document" ng-click="$ctrl.openModalEnvoyerDocument(item, {\'action\' : \'demandeDocument\'})">D\xE9poser un document</a></li><li role="menuitem"> <a ng-click="$ctrl.openModalConfirmationDeleteDemandeDocument(item)" title="Supprimer la demande">Supprimer la demande</a></li></ul></div></td></tr><tr ng-if="$ctrl.totalDemandesDocuments === 0"><td colspan="10">Aucun document.</td></tr></table></div>');
$templateCache.put('src/documents/listDocuments.html','<div class="clearfix" ng-class="{\'hiddenPager\' : $ctrl.listDocuments._settings.total <= 10}" ng-show="!$ctrl.loading"><div class="content-results"><table ng-table="$ctrl.listDocuments" class="table table-striped table-bordered table-hover table-vmiddle"><tr ng-repeat="item in $data" ng-if="$data.length > 0"><td data-title="\'Programme\'"> {{ item.programme_nom }}</td><td data-title="\'Cat\xE9gorie\'" ng-attr-title="{{ item.categorie_label }}"> {{ item.categorie_label }}</td><td data-title="\'Nom\'" ng-attr-title="{{ item.nom }}"> <span ng-if="item.titre">{{ item.titre }}</span> <span ng-if="!item.titre && item.nom">{{ item.nom }}</span></td><td> <input type="checkbox" id="document-{{item.id}}" ng-checked="$ctrl.isChecked(item)" ng-click="$ctrl.selectionDocuments(item)"><label for="document-{{item.id}}" class="checkbox"></label></td></tr><tr ng-if="$data.length === 0"><td colspan="10"><p> Aucun document</p></td></tr></table></div></div><div class="scroll-footer" style="text-align:center;" ng-show="$ctrl.loading" ng-if="!$ctrl.btnShow || $ctrl.display"> <span>En chargement&nbsp;&nbsp;&nbsp;<img ng-src="{{$root.pathImageAjaxLoader}}"/></span></div>');
$templateCache.put('src/documents/listDocumentsLots.html','<div class="clearfix" ng-class="{\'hiddenPager\' : $ctrl.listDocuments._settings.total <= 10}" ng-show="!$ctrl.loading"><div class="content-results"><table ng-table="$ctrl.listDocuments" class="table table-striped table-bordered table-hover table-vmiddle"><tr ng-repeat="item in $data" ng-if="$data.length > 0"><td data-title="\'Programme\'"> {{ item.programme_nom }}</td><td data-title="\'Cat\xE9gorie\'" ng-attr-title="{{ item.categorie_label }}"> {{ item.categorie_label }}</td><td data-title="\'Nom\'" ng-attr-title="{{ item.nom }}"> <span ng-if="item.titre">{{ item.titre }}</span> <span ng-if="!item.titre && item.nom">{{ item.nom }}</span></td><td> <input type="checkbox" id="document-{{item.id}}" ng-checked="$ctrl.isChecked(item)" ng-click="$ctrl.selectionDocuments(item)"><label for="document-{{item.id}}" class="checkbox"></label></td></tr><tr ng-if="$data.length === 0"><td colspan="10"><p> Aucun document</p></td></tr></table></div></div><div class="scroll-footer" style="text-align:center;" ng-show="$ctrl.loading" ng-if="!$ctrl.btnShow || $ctrl.display"> <span>En chargement&nbsp;&nbsp;&nbsp;<img ng-src="{{$root.pathImageAjaxLoader}}"/></span></div>');
$templateCache.put('src/documents/listDocumentsProgrammeLot.html','<div class="clearfix" ng-show="!$ctrl.loading"><p class="text-center mt-1 mb-1" style="font-size: 1.8rem;">Liste des documents</p><p class="d-flex align-center justify-content-end mr-1 mb-05"> <input type="checkbox" id="documents-all" ng-model="$ctrl.checkboxSelectionnerDocuments" ng-click="$ctrl.toggleSelectionnerDocuments()"> <label for="documents-all" class="checkbox checkbox-right" style="font-weight: normal" ng-bind-html="$ctrl.labelSelectionnerDocuments">Tout s\xE9lectionner</label></p><ul class="list-group"><li class="list-group-item" ng-repeat="item in $ctrl.documentsProgrammeLot track by\n        $index"><div class="d-flex justify-content-between"><div class="d-flex flex-col j-center d-flex-1"><p class="m-0 bold">{{ item.titre }}</p><p class="m-0 text-muted small" ng-if="item.categorie_label"><em>({{ item.categorie_label }})</em></p></div><div class="d-flex align-center j-end"> <input type="checkbox" id="document-{{item.id}}" ng-checked="$ctrl.isChecked(item)" ng-click="$ctrl.selectionDocuments(item)"><label for="document-{{item.id}}" class="checkbox"></label></div></div></li></ul></div><div class="scroll-footer" style="text-align:center;" ng-show="$ctrl.loading" ng-if="!$ctrl.btnShow || $ctrl.display"> <span>En chargement&nbsp;&nbsp;&nbsp;<img ng-src="{{$root.pathImageAjaxLoader}}"/></span></div>');
$templateCache.put('src/documents/listeDocuments.html','<div class="row" ng-class="$ctrl.documentTotal < 10 ? \'hiddenPager\' : \'\'"><div class="col-xs-12"><table ng-table="$ctrl.listeDocuments" class="table table-bordered table-striped table-responsive"><tr ng-repeat="item in $data"><td> <input type="checkbox" id="document-{{item.id}}" ng-click="$ctrl.selectionDocuments(item)"><label for="document-{{item.id}}" class="checkbox"></label></td><td title="\'Cat\xE9gorie\'">{{ item.categorie_label }}</td><td title="\'Taille\'">{{ item.size | bytes }}</td><td title="\'Lien\'"><a href="{{ item.url }}" target="_blank">{{ $ctrl.titreLien(item.nom, item.titre) }}</a></td></tr></table></div></div>');
$templateCache.put('src/documents/listeDocumentsPanelUl.html','<div class="panel"><div class="panel-heading" ng-if="$ctrl.showPanelHeading"><h3 class="panel-title h4">Documents</h3></div><div class="panel-body"><ul class="list-unstyled" ng-if="$ctrl.listeDocuments.length > 0"><li ng-repeat="item in $ctrl.listeDocuments"><i class="glyphicon" ng-class="$ctrl.getMimeIcon(item.mime_type)"></i> <a href="{{ item.url }}" target="_blank" class="text-muted"><span ng-if="item.categorie_label">{{ item.categorie_label + \' : \' }}</span> {{ item.titre }} <span ng-if="!item.titre">{{ item.nom }}</span></a></li></ul><p ng-if="$ctrl.listeDocuments.length === 0"> Aucun document</p></div></div>');
$templateCache.put('src/documents/listeDocumentsUl.html','<div ng-class="$ctrl.totalDocuments < 10 ? \'hiddenPager\' : \'\'" ng-if="$ctrl.showColCheckbox"><h4>Documents disponibles <button class="btn btn-tertiary btn-sm pull-right mt--05" ng-if="$ctrl.view !== \'programme\'" ng-click="$ctrl.openModalEnvoyerDocument(\'null\',  {\n\t\t\t\t\'action\' : \'envoyerDocument\'\n\t\t\t})">D\xE9poser un document</button> <button class="btn btn-tertiary btn-sm pull-right mt--05" ng-if="$ctrl.view === \'programme\'" ng-click="$ctrl.openModalEnvoyerDocument(\'null\',  {\n\t\t\t\t\'action\' : \'programme\',\n\t\t\t\t\'programme\' : $ctrl.programme\n\t\t\t})" admin-only>D\xE9poser un document</button></h4><table ng-table="$ctrl.tableListeDocuments" class="table table-bordered table-striped table-responsive table-center mt-1"><tr ng-repeat="item in $data"><td class="td-checkbox"> <input type="checkbox" id="document-{{item.id}}" ng-click="$ctrl.selectionDocuments(item)"><label for="document-{{item.id}}" class="checkbox"></label></td><td title="\'Cat\xE9gorie\'">{{ item.categorie_label }}</td><td title="\'Nom\'">{{ item.titre }} <span ng-if="!item.titre">{{ item.nom }}</span></td><td title="\'\'" style="width: 115px;"><div class="btn-group" uib-dropdown is-open="status.isopen"> <button id="button-signature" type="button" class="btn btn-secondary" uib-dropdown-toggle ng-disabled="disabled"> Action<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="button-signature"><li role="menuitem"> <a href="{{ item.url }}" target="_blank" title="Voir le document">Voir le document</a></li><li role="menuitem" admin-only ng-if="!$ctrl.useAdminPromoteurOnly"> <a ng-click="$ctrl.openModalConfirmationDeleteDocument(item)">Supprimer le document</a></li><li role="menuitem" admin-promoteur-only ng-if="$ctrl.useAdminPromoteurOnly"> <a ng-click="$ctrl.openModalConfirmationDeleteDocument(item)">Supprimer le document</a></li></ul></div></td></tr><tr ng-if="$ctrl.totalDocuments === 0"><td colspan="10">Aucun document.</td></tr></table></div><div ng-class="$ctrl.totalDocuments < 10 ? \'hiddenPager\' : \'\'" ng-if="!$ctrl.showColCheckbox"><h4>Documents disponibles <button class="btn btn-tertiary btn-sm pull-right mt--05" ng-click="$ctrl.openModalEnvoyerDocument(\'null\',  {\n\t\t\t\t\'action\' : \'envoyerDocument\',\n\t\t\t})">D\xE9poser un document</button></h4><table ng-table="$ctrl.tableListeDocuments" class="table table-bordered table-striped table-responsive table-center mt-1"><tr ng-repeat="item in $data"><td title="\'Cat\xE9gorie\'">{{ item.categorie_label }}</td><td title="\'Nom\'">{{ item.titre }} <span ng-if="!item.titre">{{ item.nom }}</span></td><td title="\'\'" style="width: 115px;"><div class="btn-group" uib-dropdown is-open="status.isopen"> <button id="button-signature" type="button" class="btn btn-secondary" uib-dropdown-toggle ng-disabled="disabled"> Action<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="button-signature"><li role="menuitem"> <a href="{{ item.url }}" target="_blank" title="Voir le document">Voir le document</a></li><li role="menuitem"> <a ng-click="$ctrl.openModalConfirmationDeleteDocument(item)">Supprimer le document</a></li></ul></div></td></tr><tr ng-if="$ctrl.totalDocuments === 0"><td colspan="10">Aucun document.</td></tr></table></div>');
$templateCache.put('src/documents/modal-confirmation-delete-demande-document.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"><div class="row"><div class="col-xs-12"><p>Supprimer la demande de document "<strong>{{ $ctrl.document.media_categorie_label }}</strong>"</p></div></div></div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$close()">Annuler</button> <button class="btn btn-secondary" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Confirmer</span></button></div>');
$templateCache.put('src/documents/modal-confirmation-delete-document.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"><div class="row"><div class="col-xs-12"><p>Supprimer le document "<strong>{{ $ctrl.document.titre }} <span ng-if="!$ctrl.document.titre">{{ $ctrl.document.nom }}</span></strong>"</p></div></div></div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$close()">Annuler</button> <button class="btn btn-secondary" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Confirmer</span></button></div>');
$templateCache.put('src/documents/modal-confirmation-list-demandes-documents.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"><div class="row"><div class="col-xs-12"><p>Vous avez bien re\xE7u le document "<b>{{ $ctrl.demandeDocument.media_categorie_label }}</b>"</p></div></div></div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$ctrl.annuler()">Annuler</button> <button class="btn btn-secondary" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Confirmer</span></button></div>');
$templateCache.put('src/documents/modal-demande-documents.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Demande de documents \xE0 {{ $ctrl.contact.nom + \' \' + $ctrl.contact.prenom }}</h3></div><div class="modal-body" id="modal-body"><div class="row" ng-if="!$ctrl.showMessage"><div class="col-xs-12 col-md-6 col-md-offset-3"><div class="form-group m-0 border-left"><div class="form-group--select" ng-if="$ctrl.listCategories"> <i class="material-icons">arrow_drop_down</i><multiselect name="listCategories" model-string-to-object-array classes-btn="\'form-control\'" ng-model="$ctrl.demandeDocuments.categories" options="$ctrl.listCategories" placeholder="Document(s) demand\xE9(s)" labels="$ctrl.labelMultiSelect" id-prop="id" display-prop="label" show-search="false" show-select-all="false" show-unselect-all="false"></multiselect></div></div></div><div class="col-xs-12 mt-2" ng-if="$ctrl.showCommentaire"><textarea class="form-control" rows="3" ng-model="$ctrl.demandeDocuments.note" placeholder="Commentaire"></textarea></div></div><div class="row" ng-if="$ctrl.showMessage"><div class="col-xs-12"><p class="label label-warning">Pour demander des documents, le contact doit \xEAtre attribu\xE9 \xE0 un vendeur.</p></div></div></div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$ctrl.annuler()" ng-if="!$ctrl.showMessage">Annuler</button> <button class="btn btn-secondary" type="button" ng-click="$ctrl.valider()" ng-disabled="!$ctrl.demandeDocuments.categories" ng-if="!$ctrl.showMessage" promise-btn><span class="btn-text">Envoyer la demande</span></button> <button type="button" class="btn btn-primary" ng-if="$ctrl.showMessage" ng-click="$close()">OK</span></button></div>');
$templateCache.put('src/documents/modal-upload-document.html','<div class="modal-header"><h3 class="modal-title" id="modal-title">{{ $ctrl.titleModal }}</h3></div><div class="modal-body" id="modal-body"><div ng-if="$ctrl.viewSend === 0"><div class="row mb-1" ng-if="$ctrl.listDocumentsDemandes.length > 0"><div class="col-xs-12"> <input id="documentConcerneDemande" type="checkbox" checked="checked" ng-model="$ctrl.checkboxDemandeDocument"> <label for="documentConcerneDemande" class="checkbox">Votre document concerne une demande de document ?</label></div><div class="col-xs-12 bg-gray-shadow mt-1" ng-if="$ctrl.checkboxDemandeDocument"><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control w-100" ng-model="$ctrl.demandeSelected" ng-options="item as (item.media_categorie_label + \' - \' + (item.date_creation.date | moment:\'DD/MM/YYYY\')) for item in $ctrl.listDocumentsDemandes"><option value="">S\xE9lection une demande dans la liste</option></select></div></div></div><div class="row mb-1" ng-if="!$ctrl.checkboxDemandeDocument && $ctrl.objData.action === \'envoyerDocument\'"><div class="col-xs-12"><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control w-100" ng-model="$ctrl.categorieSelected" ng-options="item.label for item in $ctrl.listCategories"><option value="">S\xE9lectionner une cat\xE9gorie</option></select></div></div></div><div class="row mb-1" ng-if="$ctrl.objData.action === \'programme\'"><div class="col-xs-12"><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control w-100" ng-model="$ctrl.categorieSelected" ng-options="item.label for item in $ctrl.listCategoriesProgramme"><option value="">S\xE9lectionner une cat\xE9gorie</option></select></div></div></div><div class="text-center mb-1"><upload-documents-btn documents="$ctrl.listUploadDocuments" title-button="\'Choisir un fichier\'" pattern="\'.jpg,.jpeg,.pdf,.odt,.ods,.docx,.doc,.xls,.xlsx,.png\'" use-base64="false" total-size="$ctrl.totalSizeListUploadDocuments"></upload-documents-btn></div><p class="mt-4">Documents s\xE9lectionn\xE9 ( <span class="file-size" ng-class="{\'oversize-file\': $ctrl.totalSizeListUploadDocuments > $ctrl.maxSizeFiles }">{{ $ctrl.totalSizeListUploadDocuments | bytes }} / {{ $ctrl.maxSizeFiles | bytes }}</span> )</p> <span class="well well-custom-1" ng-repeat="item in $ctrl.listUploadDocuments" ng-click="$ctrl.supprimerDocuments($ctrl.listUploadDocuments, $index)"><i class="material-icons delete">delete</i> <span>{{ item.name }}</span></span></div><div class="upload-file" ng-if="$ctrl.viewSend === 1 && !$ctrl.errorUploadFiles"><h4 class="mt-2 text-center">Upload des fichiers</h4><ul class="unstyled mt-3"><li ng-repeat="f in $ctrl.listUploadDocuments" class="mb-05">{{f.name}} {{f.$errorParam}}<span class="progress" ng-show="f.progress >= 0"><uib-progressbar animate="true" max="100" value="f.progress"> <span style="color:white; white-space:nowrap;">{{ f.progress }}%</span></uib-progressbar></span></li><li ng-repeat="f in errFiles" style="font:smaller">{{f.name}} {{f.$error}} {{f.$errorParam}}</li></ul></div><div class="error-upload" ng-if=\'$ctrl.errorUploadFiles\'> {{ $ctrl.errorUploadFiles }}</div><div class="alert alert-success" ng-if="$ctrl.viewSend === 2"><p>Votre document a bien \xE9t\xE9 envoy\xE9.</p></div></div><div class="modal-footer"> <button class="btn btn-sm btn-tertiary" type="button" ng-if="$ctrl.viewSend === 0" ng-click="$close()">Annuler</button> <button class="btn btn-sm btn-secondary" type="button" ng-click="$ctrl.upload()" ng-if="$ctrl.viewSend === 0" ng-disabled="$ctrl.checkBtnSubmit()" promise-btn><span class="btn-text">Envoyer</span></button> <button type="button" ng-if="$ctrl.viewSend === 2 || $ctrl.errorUploadFiles" class="btn btn-sm btn-tertiary" ng-click="$close()">OK</span></button></div>');
$templateCache.put('src/documents/uploadDocumentsBtn.html','<button type="file" class="btn btn-primary" multiple ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-resize-if="$width > 2500 || $height > 2500" ngf-resize="{width: 2500, quality: 1}" ngf-max-height="5500" ngf-fix-orientation="true" ngf-max-size="{{ $ctrl.maxSize }}" ngf-pattern="\'{{ $ctrl.pattern }}\'">{{ $ctrl.title }}</button>');
$templateCache.put('src/documents/uploadDocumentsDragDrop.html','<div class="drop-box" ngf-drop="$ctrl.uploadFiles($files)" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-pattern="\'{{ $ctrl.pattern }}\'"><span>{{ $ctrl.title }}</span></div>');}]);